import { SIGN_OUT_SUCCESS } from 'modules/auth'

import { UPDATE_QUEUE_FILTER } from '../action-types'

export default function(state = '', {type, payload}) {
  switch (type) {
    case UPDATE_QUEUE_FILTER:
      return payload

    case SIGN_OUT_SUCCESS:
      return ''

    default:
      return state
  }
}



// WEBPACK FOOTER //
// ./src/modules/links/reducers/filter.js